import questions from "../../assets/js/helpMultilngual/bs_en_questions";
import troubles from "../../assets/js/helpMultilngual/bs_en_troubles";
const en = {
  language: "english",
  bstext: {
    bs1: "Battery swapping plan",
    bs2: "Plan details",
    bs3: "Instructions",
    bs4: "Register the plan",
    bs5: "Next step",
    bs6: "Confirm",
    bs7: "Change the plan",
    bs8: "Battery swapping plan",
    bs9: "Succeed",
    bs10: "Registered successfully",
    bs11:
      " Please activate it in a Blueshark offline store ASAP to enable battery swapping function. If you want to cancel it after activation, please go to an offline service center for cancellation.",
    bs12: "Return in {msg} s",
    bs13: "Bill history",
    bs14: "To be paid",
    bs15: "No available bill info",
    bs16: "year",
    bs17: "Bill in {msg}",
    bs18: "Bill amount in {msg}",
    bs19: "plan fee",
    bs20: "Single Battery Plan",
    bs21: "Double Batteries Plan",
    bs22: "Battery swapping fee",
    bs23: "Ah sum of battery swapping this month",
    bs24: "Ah",
    bs25: "Change fee",
    bs26: "Upgrade fee",
    bs27: "Payment time",
    bs28: "Way to pay",
    bs29: "Notes for expenses",
    bs30: "bill = plan fee + battery swapping fee + change fee",
    bs31:
      "plan fee = fixed fee of monthly plan (count according to actual service days if the plan is used for less than a month) ",
    bs32:
      "Battery swapping fee = amp-hr sum of paid battery swapping within the specific cycle * TWD 2",
    bs33:
      "Change fee = fee for upgrade if the plan has been used for above 3 months",
    bs34: "Go to pay",
    bs35: "Settled bills",
    bs36: "No info yet",
    bs37: "Unsettled bills",
    bs38: "Up to now",
    bs39: "Items not billed",
    bs40: "Bill date",
    bs41: "Final payment date",
    bs42: "To ensure normal use, please pay ASAP",
    bs43: "No available bill info",
    bs44: "My bill",
    bs45: "Register",
    bs46: "Service not yet available",
    bs47: "My plan",
    bs48: "Please select the plan you want to change",
    bs49: "Registering time",
    bs50: "Activation time",
    bs51: "Termination time",
    bs52: "Change time",
    bs53: "Cancel the plan",
    bs54:
      "Your original plan has been used for over 3 months. If you change your plan, TWD 3,000 of operation expenses will be charged and be included in the bill of this month. Please confirm your change.",
    bs55: "Not now",
    bs56: "I am aware. Confirm the change",
    bs57: "Sure to cancel?",
    bs58: "Cancel",
    bs59: "Confirm",
    bs60: "My plan",
    bs61: 'You have cancelled the "{msg}" plan.',
    bs62:
      "Your original plan has been used for over 3 months. If you change your plan, TWD 3,000 of operation expenses will be charged and be included in the bill of this month. ",
    bs63: "Confirmation",
    bs64:
      'You have applied for changing your plan to "{name}", which will take effect next day. After change, the bill of this month will count the expenses according to the actual service days of these two plans involved. Please confirm it!',
    bs65: "Amount payable",
    bs66: "Please select the payment method",
    bs67: "Payment",
    bs68: "Error code:",
    bs69: "Done",
    bs70: "Repay",
    bs71: "Cancel the payment",
    bs72: "Loading",
    bs73: "Paid successfully",
    bs74: "Payment failed",
    bs75: "Go To URL"
  },
  bsstatus: {
    // 结算周期
    cycles: [
      {
        key: 1,
        val: "month"
      }
    ],
    // 套餐状态
    menus: [
      {
        key: "1",
        val: "Not activated"
      },
      {
        key: "2",
        val: " In service"
      },
      {
        key: "3",
        val: "Changed"
      },
      {
        key: "4",
        val: "Terminated"
      }
    ],
    // 支付方式
    payMethods: [
      {
        key: "CARD",
        val: "Credit Card"
      },
      {
        key: "BANK",
        val: "Bank Transfer"
      },
      {
        key: "VBANK",
        val: "Virtual Account"
      }
    ],
    // 支付状态
    payStatuss: [
      {
        key: "1",
        val: "To be paid"
      },
      {
        key: "2",
        val: "Paid"
      },
      {
        key: "3",
        val: "Overdue"
      },
      {
        key: "4",
        val: "Unsettled"
      }
    ]
  },
  helpCenter: {
    documentTitle: "Help center",
    title: [
      "Bind&Activate the Vehicle",
      "Account Issues",
      "Driving",
      "ADAS",
      "Information & Entertainment",
      "App Use Guide",
      "Vehicle Update",
      "Battery Safety",
      "Maintenance",
      "Self-Check for Errors"
    ],
    description: "Description:",
    solution: "Suggested Solution:",
    exAssistance: "Battery Swapping Help",
    exAssistanceList: [
      "About BlueShark Smart Battery Swapping Service",
      "About Battery Swap Account",
      "About Battery Swap Plans",
      "About how to use the battery swapping service"
    ],
    exAssistanceSubtitle: [
      ["About BlueShark Smart Battery Swapping Service"],
      [
        "How to Obtain Battery Swap Account?",
        "What are the uses of a battery swap account?"
      ],
      [
        "What is a Battery Swap Plan?",
        "Can the remaining quota from this month be carried over and used in the next month?",
        "Is it possible to get a refund for purchased battery swapping plan?",
        "Is it possible to renew the purchased battery swapping plan?",
        "What are the rules for the effective date of the battery swapping plan?"
      ],
      [
        "After purchasing the plan, how do I perform the first battery swapping?",
        "How to perform a battery swapping?",
        "How can I check the battery information at various battery swapping station locations?",
        "What are the possible reasons for a failed battery swapping?"
      ]
    ],
    exAssistanceInfo: [
      [
        [
          "Blueshark smart Battery Swapping Service is a quick energy replenishment service provided by Blueshark for specific demand markets. This includes installing battery swapping stations, offering battery leasing services, and swap functionalities. It effectively addresses the drawback of insufficient range in electric motorcycles and can achieve replenishment and battery swapping in as fast as 3 seconds. ",
          "Due to varying demand situations in different markets, the Blueshark smart Battery Swapping Service doesn't fully cover all sales regions of Blueshark vehicles. In some sales areas, relevant battery swap and replenishment services are not provided. For specific details, please consult local sales outlets or dealers."
        ]
      ],
      [
        [
          "If the Blueshark smart Battery Swapping Service is available in your area, you will first need to download the Blueshark app and successfully register an app account. On the app's homepage, you will find the 'Battery Swapping Service' feature card. ",
          "Select the 'Battery Swapping Service' feature card, choose a suitable battery swapping operator, read and agree to the 'Battery Swapping Service Agreement,' and you will be able to create your swapping account. ",
          "If the Blueshark smart Battery Swapping Service is not yet available in your area, you won't be able to access the 'Battery Swapping Service' feature card and won't be able to create a battery swap account."
        ],
        [
          "The battery swapping account is the sole identity account used for accessing Blueshark smart Battery Swapping Service. Without a battery swap account, you won't be able to enjoy the benefits of the battery swapping service. The battery swap account can be used for purchasing swapping packages, using the swapping service, managing swapping limits and assets, and keeping track of swapping records and consumption."
        ]
      ],
      [
        [
          "Battery swapping plans are virtual electronic commodities of benefits created by various battery swapping operators offering services, based on the specific demands of swapping businesses in different regions. ",
          "Currently, plan rules support three billing methods: charging based on electricity consumption, charging based on the number of battery swaps, and unlimited battery swap quotas. Quotas are allocated on a monthly basis, and billing can be done on a monthly, quarterly, or yearly basis. The specific available plans depend on the actual rules set by the chosen operator. ",
          "Upon purchasing a battery swapping plan, you can enjoy the benefits of battery swapping services. You can visit offline stores or dealers to claim your battery swapping service benefits and then use the swapping service."
        ],
        [
          "According to the current battery swapping service rules, any unused quota for the current month will be reset when entering the next month's billing cycle and will not accumulate into the next month. Please choose a battery swapping plan that suits your actual electricity usage needs for daily use."
        ],
        [
          "Battery swapping plans are virtual benefits in the form of electronic commodities, and according to the battery swapping usage rules, refunds are not possible. We recommend evaluating your purchase carefully to avoid any losses. Thank you for your understanding."
        ],
        [
          "When purchasing a battery swapping plan, please pay attention to the renewal rules of the plan. As long as you meet the renewal criteria, it is possible to renew the plan. After renewal, your battery swapping benefits will continue to accumulate on the 'My Swapping' page. Please make plans and renewals based on your actual needs."
        ],
        [
          "After purchasing a battery swapping plan, it will become effective on the 1st day of the next month. Please note that if you need immediate effect, you should select the 'Apply Immediately in Current Month' option and ensure that the plan quota for the current month is sufficient. This will allow the battery swapping plan to take immediate effect. When purchasing a battery swapping plan, please plan the activation time of the plans reasonably according to your personal needs."
        ]
      ],
      [
        [
          "After purchasing the battery swap plan, the first step is to follow the app's instructions and visit an offline store or dealer's location to claim the battery swapping service benefits and register the battery. If the battery is a leased battery, you'll need to visit an offline store or dealer's location to lease the battery and pay the battery lease deposit. ",
          "Once registered, the battery is eligible for the battery swapping service benefits. You can insert the battery into the battery swapping station, and the station will automatically dispense a fully charged or high-capacity battery, binding the battery swapping service benefits to the newly dispensed battery."
        ],
        [
          "After the user completes the initial battery registration for the first swapping, for each subsequent battery swapping, simply insert a low-charge battery into an empty slot in the battery swapping station, and the station will automatically dispense a fully charged or high-capacity battery. ",
          "If the battery swapping station fails to dispense the battery as expected, follow the instructions displayed on the station's screen and contact customer service for assistance."
        ],
        [
          "You can select the battery swapping service in the Blueshark app, go to the battery swapping map homepage, and find information about nearby battery swapping stations. This information includes the station's name, location, distance from you, and an overview of the battery status. By clicking on a specific battery swapping station, you can access its detailed information page and view the battery information for that selected station."
        ],
        [
          "There are several possible reasons for a failed battery swapping:",
          "① The inserted battery has an expired battery swapping service, which prevents a successful swap. You should renew the service before using it.",
          "② The battery swapping station has no available batteries for swapping, meaning that the batteries inside the station do not meet the swapping conditions. In this case, you can try another station for swapping.",
          "③ If none of the above situations apply and you still experience repeated failures in battery swapping, please contact customer support for assistance."
        ]
      ]
    ],
    quickGuide: "Quick Guide to Vehicle Operation",
    quickGuideList: [
      "Basic Operations",
      "Vehicle activation",
      "Parking function",
      "Driving function",
      "Riding and Mode"
    ],
    QuickListSubtitle: [
      ["Basic Operations for H1 2023", "Basic operation of R1 2023"],
      ["H1 2023 Vehicle activation", "R1 2023 Vehicle activation"],
      ["H1 2023 Parking function", "R1 2023 Parking function"],
      ["H1 2023 Driving function", "R1 2023 Driving function"],
      ["H1 2023 Riding and Mode", "R1 2023 Riding and Mode"]
    ],
    h1Node:
      "Note: This guide is only applicable to H1 2023. For H1 lite, please refer to the instruction manual. This guide is for quick start use only. For detailed operation, please refer to the instruction manual.",
    r1Node:
      "Note: This guide is only applicable to R1 2023. For R1 lite, please refer to the instruction manual. This guide is for quick start use only. For detailed operation, please refer to the instruction manual.",
    lightDescription: "Indicator Light Explanation",
    signalLeft: "Left Turn Signal",
    signalRight: "Right Turn Signal",
    highBeam: "High Beam",
    lowBeam: "Low Beam",
    lowPowerLight: "Low Battery Warning Light",
    faultLight: "Fault warning light",
    readyLight: "Ready Indicator Light",
    instrumentPic: "Dashboard diagram",
    leftKeyDescription: "Button instructions (left handle)",
    leftHandPic: "Left handle diagram",
    rightKeyDescription: "Button instructions (right handle)",
    rightHandPic: "Right Handlebar Schematic",
    overtakingLightKey: "Pass switch: Toggle the light to flash",
    lowBeanKey: "Low beam switch: toggle to turn on low beam",
    highBeamKey: "High beam switch: Turn on high beam by toggling",
    configKey:
      "Confirm button: Used for confirmation operation in multi-function card",
    smartKey:
      "Intelligent button: Used for switching and card control in multi-function card",
    LeftTrunSignalKey:
      "Turn signal switch: Turn on left turn signal by toggling to the left, press the middle to turn off",
    RightTrunSignalKey:
      "Turn signal switch: Turn on right turn signal by toggling to the right, press the middle to turn off",
    hornKey: "Horn button: Press and hold to honk the horn, release to stop",
    cruiseControlKey:
      "Cruise control button: Short press to turn on cruise control (speed over 15km/h), short press again or brake to turn off",
    waringKey:
      "Hazard warning light switch: Press to turn on hazard warning lights when vehicle has breakdown or emergency",
    costomKey: "Custom button: To be filled in",
    turboKey:
      "TURBO button: Short press to enter TURBO mode, short press again to exit TURBO mode",
    sportKey:
      "SPORT button: Short press to enter SPORT mode, short press again to exit SPORT mode",
    openSeatKey:
      "Seat opening button: Short press to open the seat when the vehicle is electrified",
    transferAssistanceKey:
      "Assistive Moving Key: When the vehicle is in riding state and stationary, press the MAM key to enter the assistive moving mode. At this time, you can operate the vehicle to move slowly back and forth by turning the 'M' or the handlebar.",
    gearKey: "Mode button: Short press to switch mode",
    LeftGearKey: "Mode key: Shift down mode by turning left mode key",
    RightGearKey: "Shift key: shift up when shifted rightward",
    volumeIncreaseKey:
      "Volume control key: short press the right button to increase the volume",
    volumedecreaseKey:
      "Volume control key: short press the left key to decrease volume",
    readyKey:
      "Ready button: Short press to switch between driving and parking mode",
    activationNode:
      "Note: The vehicle is in an inactive state upon delivery and needs to be activated to use all features and services.",
    activeCardPic: "Vehicle activation card illustration",
    activeUIPic: "Vehicle activation interface illustration",
    activeStep1: "Step 1: First Boot Page",
    activeStep2: "Step 2: App download guide page",
    activeStep3: "Step 3: Activation Page Guide",
    activeStep4: "Step 4: Activation Result Page",
    activeStepInfo1: "When this card appears on the vehicle, press",
    activeStepInfo2: "shortly to enter the activation process",
    activeStepInfo3:
      "The app can be downloaded on Android/iOS market;If already downloaded, short press",
    activeStepInfo5: "to proceed to the next step",
    activeStepInfo6:
      "Follow the App instructions to search for the vehicle, find the corresponding vehicle, and enter the 4-digit PIN code displayed on the vehicle dashboard to complete the activation.",
    activeStepInfo7:
      "After successful activation, you will be redirected to the success page (Please note that you have to complete this operation within 5 minutes, otherwise the activation process will restart.)",
    instrumentDescription: "Instrument panel overall explanation",
    instrumentStopPic: "Instrument (parked state) schematic ",
    instrumentWorkPic: "Instrument panel (driving status) illustration",
    cardPic: "Aggregate card illustration",
    instrumentInfo1:
      "Smart card area (including aggregate cards, riding statistics, Bluetooth music, Bluetooth settings, vehicle health, vehicle settings)",
    instrumentInfo2:
      "Central information area (including vehicle health status, vehicle driving statistics)",
    instrumentInfo3:
      "Vehicle Information Area (including mode position, range information, function enable status)",
    aggregatedCardArea: "Smart card area - Aggregate cards",
    aggregatedCardInfo1:
      "Display the playback status of Bluetooth music, the status of music function can be judged based on the prompt text in the music function",
    aggregatedCardInfo2:
      "Display the connection status of Bluetooth, when not connected, the icon color is gray, when connected successfully, the icon color is colorful",
    aggregatedCardInfo3:
      "Display the on-off status of the driving recorder, when not turned on, the icon color is gray, when turned on, the icon color is colorful",
    aggregatedCardInfo4: "The function is not yet available, please stay tuned",
    cyclingStatistics: "Smart card area - Riding statistics",
    cyclingPic: "Cycling statistics illustration",
    cyclingStatisticsInfo1:
      "This shows the total mileage of the vehicle since it left the factory",
    cyclingStatisticsInfo2:
      "This shows your mileage for a specific trip, you can short press ",
    cyclingStatisticsInfo3: "to reset this data",
    BluetoothMusic: "Smart card area - Bluetooth music",
    BluetoothPic: "Bluetooth music illustration",
    BluetoothMusicInfo1:
      "When there is audio, the singer and lyrics names are displayed here. When there is no audio, 'Unknown song' is displayed here (Bluetooth connection and audio playback through a mobile device are required)",
    BluetoothMusicInfo2: "Short press",
    BluetoothMusicInfo3: "to control play/pause music",
    BluetoothMusicInfo4: "Long press",
    BluetoothMusicInfo5: "to switch to the next song",
    vehicleHealth: "Smart card area - Vehicle health",
    healthPic: "Vehicle health illustration",
    warningPic: "Vehicle anomaly illustration",
    vehicleHealthInfo1:
      "After starting the vehicle, switch to this card, and it will automatically detect the vehicle's health status",
    vehicleHealthInfo2:
      "When there is a problem with the vehicle's health status, the corresponding fault information will be displayed on the card, and the fault details can be viewed by short pressing the",
    vehicleHealthInfo3: "button",
    vehicleSetting: "Smart card area - Vehicle settings",
    settingPic: "Vehicle settings diagram",
    vehicleSettingInfo1:
      "This function allows you to set up the vehicle (settings include: Bluetooth volume, motorcycle sound, display mode, vehicle version, language settings, driving recorder, factory reset, safety assistance, pending binding mode, distance unit, time unit)",
    vehicleSettingInfo2:
      "To switch between different functions, you can short press ",
    vehicleSettingInfo3: "to control",
    vehicleSettingInfo4:
      "When you find the function you need and want to confirm, you can short press ",
    vehicleSettingInfo5: "to confirm",
    instrumentWorkingInfo1:
      "Smart card area (including aggregated cards, cycling statistics, Bluetooth music)",
    instrumentWorkingInfo2:
      "Central information area (including real-time speed, battery information)",
    instrumentWorkingInfo3:
      "Vehicle Information Area (including mode position, range information, real-time current, real-time power consumption)",
    aggregatedCardWorkingInfo2: "Display current cycling data",
    startCycling: "Start riding",
    startInfo:
      "Briefly press the 'Ready' button to enter or exit cycling mode, the instrument panel displays the corresponding screen (see below for details)",
    gearShift: "Mode switching",
    gearNote:
      "Note: The vehicle has a total of five modes, which are 【ECO】【COMFORT】【SPORT】【TURBO】【MAM】",
    H1GearNote:
      "Note: The vehicle has four modes in total, namely【ECO】, 【COMFORT】, 【SPORT】, and 【MAM】.",
    gearInfo1:
      "ECO mode is suitable for energy-efficient driving and can provide the longest range",
    gearInfo2:
      "COMFORT mode is suitable for daily driving and balances range, acceleration, and top speed",
    gearInfo3:
      "SPORT mode is suitable for sporty driving and highlights overtaking and top speed performance",
    gearInfo4:
      "TURBO mode is suitable for intense driving and unleashes the full potential of the vehicle",
    gearInfo5: "MAM mode is suitable for pushing/moving the vehicle",
    gearInfo6: "Shift modes by moving the M key to the left or right",
    gearInfo7: "Press the TURBO key to enter TURBO mode",
    gearInfo8:
      "Press and hold this button to enter MAM mode, and then turn the handle or shift M- / M+ to control vehicle movement (M- for reverse; M+ for forward)",
    gearInfo9: "Press M key to switch modes",
    gearInfo10:
      "Press and hold this button to enter MAM mode, then you can use M-/M+ to control vehicle movement (M- for reverse; M+ for forward).",
    drivingPage: "Driving page",
    parkingPage: "Parking page",
    gearPic: "Mode information display area diagram",
    troubles,
    questions
  }
};

export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js